export default __webpack_public_path__ + "static/media/7.1c905123.jpg";